import { IQuickReplyTemplate } from './client';
import { QuickReplyTemplateServer } from './server';

export const normalizeQuickReplyTemplate = (
  raw: QuickReplyTemplateServer
): IQuickReplyTemplate => ({
  id: raw._id,
  name: raw.name,
  body: raw.body,
  dateUpdated: new Date(raw.date_updated)
});

export const quickReplyTemplateToListItem = (
  raw: QuickReplyTemplateServer
): {
  entity: IQuickReplyTemplate;
  key: string;
} => ({
  entity: normalizeQuickReplyTemplate(raw),
  key: raw._id
});
